import { render } from "./ProfilePanelInformation.vue?vue&type=template&id=2584727e&scoped=true"
import script from "./ProfilePanelInformation.vue?vue&type=script&lang=js"
export * from "./ProfilePanelInformation.vue?vue&type=script&lang=js"

import "./ProfilePanelInformation.vue?vue&type=style&index=0&id=2584727e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2584727e"]])

export default __exports__